module.exports = __webpack_public_path__ + "media/images/arrows/tail-spin-e5cd8a0af247a76988f748923c9db960.svg";